import styled from 'styled-components';

export const Container = styled.main`
  width: 100%;
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;

  div {
    width: 80%;
    padding: 0 137px;
  }

  img {
    width: 1000px;
  }
`